import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import * as WhiteLable from "../components/Common/WhiteLable";

const capitalizeFirstLetter = (string) => {
  return string.charAt(1).toUpperCase() + string.slice(2);
};

const NonAuthLayout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const currentage = capitalizeFirstLetter(location.pathname);
    document.title = currentage + " | " + WhiteLable.getAppName();
  }, [location.pathname]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default NonAuthLayout;
